import { create } from 'zustand';

const reimbursementStore = (set, get) => ({
    tableData: [
        {
            id: 1,
            qty: 1,
            description: '',
            price: '0.00',
            total: '0.00'
        }
    ],

    addRow: () => {
        set((state) => {
            return {
                tableData: [
                    ...state.tableData,
                    {
                        id: Math.random(),
                        qty: 1,
                        description: '',
                        price: '0.00',
                        total: '0.00'
                    }
                ]
            };
        });
    },

    updateRow: (value, field, id) => {
        const tableData = get().tableData;
        const updatedValues = tableData?.map((eachRow) => {
            if (eachRow.id === id) {
                const total = parseFloat(eachRow.qty) * parseFloat(eachRow.price);
                return {
                    ...eachRow,
                    [field]: typeof value === 'number' ? value?.toFixed(2) : value,
                    total
                };
            }
            return eachRow;
        });
        set((state) => {
            return {
                tableData: updatedValues
            };
        });
    },

    deleteRow: (value, field, id) => {
        const tableData = get().tableData;
        const updatedValues = tableData.filter((e) => e.id !== id);
        set((state) => {
            return {
                tableData: updatedValues
            };
        });
    }
});

const useReimbursementStore = create(reimbursementStore);
export default useReimbursementStore;
